import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import { injectIntl } from 'react-intl';
import { grey500 } from 'material-ui/styles/colors';
import moment from 'moment';

function getCollapseTimePeriodFunction(timePeriod) {
  return (arr, { date, score, count }) => {
    const lastItemTimeMs = arr[arr.length - 1] && arr[arr.length - 1].x;
    const thisItemTimeMs = moment.utc(date).startOf(timePeriod).valueOf();
    if (lastItemTimeMs === thisItemTimeMs) {
      const lastCount = arr[arr.length - 1].count;
      const lastScore = arr[arr.length - 1].y;
      arr[arr.length - 1].y = ((lastCount * lastScore) + (count * score)) / (lastCount + count);
      arr[arr.length - 1].count += count;
      return arr;
    } else {
      return arr.concat([{
        x: moment.utc(date).startOf(timePeriod).valueOf(),
        y: score,
        count: count,
      }]);
    }
  };
}

function getData(scoreByDate, intl) {
  if (!Array.isArray(scoreByDate) || scoreByDate.length <= 0) {
    return {
      data: [],
      tooltipDateFormatter: () => null,
      xAxisDateFormatter: () => null,
    };
  }

  const firstDate = scoreByDate[0].date;
  const lastDate = scoreByDate[scoreByDate.length - 1].date;
  const monthsCount = moment(lastDate).diff(moment(firstDate), 'months');

  if (monthsCount < 3) {
    return {
      data: scoreByDate.map(({ date, score, count }) => {
        return {
          x: Date.parse(date),
          y: score,
          count: count,
        };
      }),
      tooltipDateFormatter: ms => moment.utc(ms).format('dddd, D MMM Y'),
      xAxisDateFormatter: ms => moment.utc(ms).format('D MMM<br/>Y'),
    };
  } else if (monthsCount < 12) {
    return {
      data: scoreByDate.reduce(getCollapseTimePeriodFunction('isoWeek'), []),
      tooltipDateFormatter: ms => {
        return intl.formatMessage({ id: 'week' }) + moment.utc(ms).format(' W, Y');
      },
      xAxisDateFormatter: ms => {
        return intl.formatMessage({ id: 'week' }) + moment.utc(ms).format(' W<br/>Y');
      },
    };
  } else {
    return {
      data: scoreByDate.reduce(getCollapseTimePeriodFunction('month'), []),
      tooltipDateFormatter: ms => moment.utc(ms).format('MMMM Y'),
      xAxisDateFormatter: ms => moment.utc(ms).format('MMM<br/>Y'),
    };
  }
}

const styles = {
  wrapper: {
    padding: 15
  },
};

class ScoreLineChart extends Component {
  render() {
    const intl = this.props.intl;
    const scoreTitle = intl.formatMessage({
      id: 'score',
      defaultMessage: 'Score',
    });

    const {
      data,
      tooltipDateFormatter,
      xAxisDateFormatter,
    } = getData(this.props.answersReport.scoreByDate, intl);

    const chartConfig = {
      chart: {
        height: this.props.height - (styles.wrapper.padding * 2),
        width: this.props.width - (styles.wrapper.padding * 2),
      },
      title: null,
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function () {
          const score = ReactHighcharts.Highcharts.numberFormat(this.y, 1);
          const countMessage = intl.formatMessage({ id: 'numberOfAnswers' }, { count: this.point.count });
          const date = tooltipDateFormatter(this.x);
          return `
            <b>${scoreTitle}: ${score}</b>
            <br/>
            ${countMessage} 
            <br/>
            ${date}
          `;
        },
      },
      xAxis: {
        type: 'datetime',
        labels: {
          formatter: function () {
            return xAxisDateFormatter(this.value);
          },
          style: {
            color: grey500,
          },
        },
      },
      yAxis: {
        title: {
          text: scoreTitle,
          style: {
            color: grey500,
          },
        },
        min: this.props.staticYAxisScale ? 0 : null,
        max: this.props.staticYAxisScale ? 10 : null,
        tickInterval: this.props.staticYAxisScale ? 5 : null,
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
            format: '{y:.1f}',
          },
        },
      },
      series: [{
        data,
      }],
    };

    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{ id: this.props.uniqueId }}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  injectIntl(ScoreLineChart),
  graphql`
    fragment ScoreLineChart_answersReport on AnswersReport {
      scoreByDate {
        date
        score
        count
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/ScoreLineChart/ScoreLineChart.js